import React from "react";
import ListItem from "@material-ui/core/ListItem";

const SearchListItem = (props: any) => {
    const {children, onClick} = props;
    return(
        <ListItem
            button
            divider
            disableGutters
            onClick={onClick}
        >
            {children}
        </ListItem>
    )
};

export default SearchListItem;